// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"patio"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4 21V4C4 4 7 2 12 2C17 2 20 4 20 4V21H4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M8 10.5H12M8 14H12M8 17.5H12M8 8.5V21M12 21V8.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 21V4C4 4 7 2 12 2C17 2 20 4 20 4V21M4 21H3M4 21H20M20 21H21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-patio')
export default class PatioIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'patio',
    }
  }
}
